import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

export default function Footer(params) {
  const { page, navigateTo } = params;
  const [active, setActive] = useState(page);
  const navigate = useNavigate();

  return (
    <footer className="instagram-footer">
      <HomeOutlinedIcon
        className={`nav-icon ${active === "home" ? "active" : ""}`}
        onClick={() => setActive("home")}
      />

      <SearchOutlinedIcon
        className={`nav-icon ${active === "search" ? "active" : ""}`}
        onClick={() => {
            setActive("search"); 
            navigate("/notifikacije3");  
        }}
      />

      <AddBoxOutlinedIcon
        className={`nav-icon add ${active === "add" ? "active" : ""}`}
        onClick={() => {setActive("add"); navigate("/notifikacije4");}}
      />

      <SmartDisplayOutlinedIcon
        className={`nav-icon ${active === "reels" ? "active" : ""}`}
        onClick={() => {
          setActive("reels");
          navigate(navigateTo);
        }}
      />

      <AccountCircleOutlinedIcon
        className={`nav-icon ${active === "profile" ? "active" : ""}`}
        onClick={() => setActive("profile")}
      />
    </footer>
  );
}
